import { Container, ContainerProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import { HealthToolBreadcrumb } from 'components/molecules/healthToolBreadcrumb'

type _BreadcrumbProps = ContainerProps

export const _Breadcrumb = (props: _BreadcrumbProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <Container fluid bg={'#ffffff'} {...props}>
      <HealthToolBreadcrumb
        pb={16}
        pageItem={[
          {
            label: f({
              id: 'experts.allExperts',
              defaultMessage: 'Experts',
            }),
            value: `/expert`,
          },
        ]}
      />
    </Container>
  )
}
